import { render, staticRenderFns } from "./fournisseur_add.vue?vue&type=template&id=c91bf880&scoped=true&"
import script from "./fournisseur_add.vue?vue&type=script&lang=js&"
export * from "./fournisseur_add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c91bf880",
  null
  
)

export default component.exports